import L from 'leaflet';
import icon from '@/data/icon.svg';  

export const IconLocation = L.icon({
  iconUrl: icon,
  iconRetinaUrl: icon,
  iconAnchor: [17, 34],  
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [35, 35],  
  className: 'LeafLet-venue-icon',
});
